export enum FinancialsAcronymsEnum {
    SAFRA = 'safra',
    PAN = 'pan',
    FACTA = 'facta',
    DAYCOVAL = 'daycoval',
    C6 = 'c6',
}